import * as constants from '@/common/constants';
import { get, post, del } from '@/utils/http';

/** 获取档案模板列表 */
// export const getArchiveTemplate = (params = { currentPage: processId, pageSize: 10 }) => {
//   return get(constants.API_ARCHIVE_TEMPLATE_LIST, { id: processId });
// };
export const getArchiveTemplateList = (params = { currentPage: 1, pageSize: 10 }) => {
    return get(constants.API_ARCHIVE_TEMPLATE_LIST, params);
};
export const saveArchiveTemplate = (archiveTemplate) => {
    return post(constants.API_ARCHIVE_TEMPLATE_SAVE, archiveTemplate);
};
export const deleteArchiveTemplate = (archiveTemplateId) => {
    return del(constants.API_ARCHIVE_TEMPLATE_DELETE, { id: archiveTemplateId });
};
export const publishArchiveTemplate = (archiveTemplateId, state) => {
    return post(constants.API_ARCHIVE_TEMPLATE_PUBLISH.replace(':id', archiveTemplateId).replace(':state', state));
};
export const saveCopyArchiveTemplate = (archiveTemplate) => {
    return post(constants.API_ARCHIVE_TEMPLATE_SAVE_COPY, archiveTemplate);
};

export const mergeArchiveFile = (params) => {
    return post(constants.API_ARCHIVE_MERGE_ARCHIVE_FILE, params);
};
export const applyArchiveFile = (params) => {
    return post(constants.API_ARCHIVE_APPLY_ARCHIVE_FILE, params);
};

export const applySingleArchiveFileApply = (params) => {
    return post(constants.API_ARCHIVE_SINGLE_APPLY_ARCHIVE_FILE, params);
};

export const delSingleArchiveFileApprovalApply = (params) => {
    return post(constants.API_ARCHIVE_SINGLE_APPLY_ARCHIVE_FILE_DEL, params);
};

export const approvalArchiveFile = (params) => {
    return post(constants.API_ARCHIVE_APPROVAL_ARCHIVE_FILE, params);
};

export const approvalArchiveFileByIds = (params) => {
    return post(constants.API_ARCHIVE_APPROVAL_ARCHIVE_FILE_BYIDS, params);
};

export const addSaveArchiveNo = (params) => {
    return post(constants.API_ARCHIVE_SAVE_ARCHIVENO, params);
};

// 客服复制档案模板给客服
export const copyArchiveTemplateToCs = (templateId) => {
    return post(constants.API_ARCHIVE_TEMPLATE_COPY_TO_CS, { templateId });
};
// 下载文件
export const downloadFiles = (url) => {
    let _this = this;
    let canDownload = sessionStorage.getItem('canDownload');
    if (!canDownload || canDownload == 1) {
        var iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = url;
        sessionStorage.setItem('canDownload', 0);
        setTimeout(function () {
            sessionStorage.setItem('canDownload', 1);
        }, 5000);
        document.body.appendChild(iframe);
    }
};
export const setSignatureRecordParam = (param) => {
    return post(constants.API_SET_SIGNATURE_RECORDPARAM, param);
};
export const getSignatureRecord = (param) => {
    return post(constants.API_GET_SIGNATURE_RECORD, param);
};
export const getSignatureFileRecord = (param) => {
    return post(constants.API_GET_SIGNATURE_FILE_RECORD, param);
};
export const getProcessTaskInfo = (param) => {
    return post(constants.GET_PROCESS_TASK_INFO, param);
};
export const getFilePrintTimes = (param) => {
    return post(constants.GET_GETFILE_PRINTTIMES, param);
};
export const addFilePrintTimes = (param) => {
    return post(constants.GET_ADD_FILE_PRINT_TIMES, param);
};


// WEBPACK FOOTER //
// ./src/data-model/document/document-model.js